import { array, schema, string } from "@anna-money/anna-web-lib/serializer";

export class CountryData extends schema(
  {
    countries: array(string()),
  },
  "CountryData",
) {}
